import { useNavigate } from "react-router-dom"
import Logo from "./assets/ic.png"

const Sandbox = () => {

    const Navigate = useNavigate()

    return (
        <div className=" w-full h-screen flex justify-center items-center text-center flex-col bg-white">
            <img src={Logo} className=" w-[200px]" alt="" />
            <div className=" mt-4 flex divide-x-2 divide-gray-500">
                <div onClick={() => Navigate('/user/dashboard')} className=" px-4 cursor-pointer hover:underline">User</div>
                <div onClick={() => Navigate('/sales_rep/dashboard')} className=" px-4 cursor-pointer hover:underline">Sales Rep</div>
                <div onClick={() => Navigate('/admin/dashboard')} className=" px-4 cursor-pointer hover:underline">Admin</div>
            </div>
        </div>
    )
}

export default Sandbox